import React from 'react';
import RegionWrapper from '../../../frame/components/region-wrapper';
import SplitLine from '../../../frame/components/split-line';
import PopupWrapper, { PopupMenuType } from '@com-pc/popup-wrapper';
import { CommonColor } from '@editor/src/js/constants/common-color';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { NOTE_CANVAS_ID, NOTE_CONTAINER_ID } from './constant';
import { RegionType } from '@src/slide/domain/selection/constant/region';
import { IPcNoteAreaProps, IPcNoteAreaService, IPcNoteAreaState } from '@src/slide/application/service/note-area-component/core/pc/type';
import ReactView from '@src/slide/infrastructure/module/independent/view-service-define/react/react-view';
import PcNoteAreaModel from '@src/slide/application/service/note-area-component/core/pc/pc-note-area-model';
import { IBaseNoteAreaInfo } from '@src/slide/application/service/note-area-component/core/base/base-note-area-service.interface';
import { NOTE_REF_NAME } from '@src/framework/frame/components/note-area/constant';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { CustomConfig, StatusBarConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';
import { NOTE_COLLAPSE_HEIGHT } from '@src/framework/editor/src/js/constants';

const NOTE_EXTEND_LENGTH = 3; // 备注区选中高度上下扩展高度

export default class NoteAreaWrapper extends React.Component<IPcNoteAreaProps, IPcNoteAreaState> {
    public static displayName = 'NoteAreaWrapper';

    private canvasRef: HTMLCanvasElement | null;
    private noteTopDivRef: HTMLDivElement | null;
    private noteBottomDivRef: HTMLDivElement | null;
    private noteContainerRef: HTMLDivElement | null;

    private noteAreaService: IPcNoteAreaService;
    public constructor(props: IPcNoteAreaProps, content) {
        super(props, content);
        this.noteAreaService = props.getNoteAreaService();
        this.noteAreaService.setViewDelegate(new class extends ReactView<IPcNoteAreaProps> {
            public getElementById(id: string) {
                const canvasComponent = this.realView as NoteAreaWrapper;
                return canvasComponent.getRefByName(id);
            }
        }(this));
    }

    public getRefByName(name: string) {
        switch (name) {
            case NOTE_REF_NAME.NOTE_CANVAS:
                return this.canvasRef;
            case NOTE_REF_NAME.NOTE_TOP:
                return this.noteTopDivRef;
            case NOTE_REF_NAME.NOTE_BOTTOM:
                return this.noteBottomDivRef;
            case NOTE_REF_NAME.NOTE_CONTAINER:
                return this.noteContainerRef;
        }
    }

    public componentDidMount(): void {
        this.noteAreaService.componentDidMount();
    }

    public componentDidUpdate(): void {
        this.noteAreaService.componentDidUpdate();
    }

    public fixNoteHeightByResize(): void {
        this.noteAreaService.fixNoteHeightByResize();
    }

    public getNoteAreaInfo(): IBaseNoteAreaInfo {
        return this.noteAreaService.getNoteAreaInfo();
    }

    public render() {
        const { noteAreaHeight = 0 } = this.getState() || {};
        const { noteAreaShowFlag, handleSplitLineBeforeDrag,
            handleSplitLineOnDrag, handleSplitLineAfterDrag } = this.noteAreaService;

        return (<RegionWrapper region={RegionType.NOTE} style={this.props.style}>
            <PopupWrapper
                type={PopupMenuType.NOTE}
                style={{
                    position: 'absolute',
                    height: noteAreaHeight,
                    bottom: 0,
                    width: '100%',
                    overflow: 'hidden',
                }}
            >
                {
                    <div ref={((e) => {
                        this.noteContainerRef = e;
                    })}
                    id={NOTE_CONTAINER_ID}
                    style={{
                        position: 'absolute',
                        height: noteAreaHeight,
                        width: '100%',
                        overflow: 'hidden auto',
                        left: 0,
                        top: 0,
                    }}>
                        <div ref={((element) => {
                            this.noteTopDivRef = element;
                        })} />
                        <div style={{ position: 'relative' }}>
                            <canvas
                                ref={((element) => {
                                    this.canvasRef = element;
                                })}
                                id={NOTE_CANVAS_ID}
                                /**
                                 * canvas作为inline-block元素，高度与父元素一致时，base-line的对齐方式会导致底部内容超出，
                                 * 父元素会出现滚动条，因此这里需要设置 verticalAlign 使底部与整行的底部对齐。
                                 */
                                style={{ left: 0, top: 0, verticalAlign: 'bottom' }}
                            />
                        </div>
                        <div ref={((element) => {
                            this.noteBottomDivRef = element;
                        })} />
                    </div>
                }
                <div
                    style={{
                        display: noteAreaShowFlag() ? 'none' : 'block',
                        position: 'absolute',
                        top: 0,
                        width: '100%',
                        height: noteAreaHeight,
                        borderLeft: '1px solid #e7e8e9',
                        background: CommonColor.FCFCFC,
                    }}
                >
                </div>
            </PopupWrapper>
            <SplitLine
                draggable={true}
                direction="horizontal"
                beforeDrag={handleSplitLineBeforeDrag}
                onDrag={handleSplitLineOnDrag}
                afterDrag={handleSplitLineAfterDrag}
                style={{
                    position: 'absolute',
                    height: 1 + (NOTE_EXTEND_LENGTH * 2),
                    width: '100%',
                    opacity: 0.06,
                    bottom: noteAreaHeight - (NOTE_EXTEND_LENGTH * 2),
                    // splitLine 的热区下移1px， 把上边热区去掉， 因为他会遮挡上边滚动条
                    // borderTop: `${NOTE_EXTEND_LENGTH}px solid`,
                    borderBottom: `${2 * NOTE_EXTEND_LENGTH}px solid`,
                    borderColor: 'white',
                    cursor: this.getSplitLineCursorStyle(),
                }}
            />
        </RegionWrapper>);
    }

    private getSplitLineCursorStyle() {
        return browser.isWindowWxMiniProgram ? 'ns-resize' : 'row-resize';
    }

    private getState() {
        // noteAreaService 暂时不管 cac，之后修改
        const state = this.noteAreaService.getModel();

        // note 区域的大小和两个因素有关
        // 如果不显示 showNote = false，note 是折叠状态有 8px
        // 如果状态栏也不显示，note 就隐藏起来 0px
        const showNote = appConfigInstance.getConfig(CustomConfig.showNote as any) ?? true;
        const showStatusBar = appConfigInstance.getConfig(StatusBarConfig.statusBar as any) ?? true;
        if (!showNote) {
            (state as PcNoteAreaModel).noteAreaHeight = NOTE_COLLAPSE_HEIGHT;
        }
        if (!showNote && !showStatusBar) {
            (state as PcNoteAreaModel).noteAreaHeight = 0;
        }
        return state as PcNoteAreaModel;
    }
}
